import React, { ReactElement, useCallback, useEffect } from 'react';

import { AgreementsContent, useAgreements } from 'features/agreements';
import { ButtonIcon, Flex, Typography } from 'components';

interface AgreementsMessageProps {
  productSlug?: string;
}

const AgreementsMessage = ({ productSlug }: AgreementsMessageProps): ReactElement => {
  const {
    agreements,
    agreementsCount,
    showAgreementsMessage,
    setShowAgreementsMessage,
    setShowAgreement,
  } = useAgreements();

  const openAgreementContent = useCallback(
    (agreementProductSlug: string, agreementClassUuid: string) => {
      setShowAgreementsMessage(false);
      setShowAgreement([agreementProductSlug, agreementClassUuid]);
    },
    [agreements]
  );

  const closeAgreementsMessage = () => {
    setShowAgreementsMessage(false);
  };

  useEffect(() => {
    if (productSlug && agreements) {
      if (agreements[productSlug]) {
        setShowAgreementsMessage(true);
      }
    }
  }, [agreements, productSlug]);

  return (
    <>
      <AgreementsContent />

      {!!agreementsCount && !!showAgreementsMessage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 150,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '30%',
              left: '50%',
              width: '400px',
              background: 'white',
              transform: 'translate(-50%, -30%)',
              padding: 20,
              zIndex: 155,
              borderRadius: 4,
            }}
          >
            <ButtonIcon
              icon="close"
              iconWidth={18}
              width={30}
              height={30}
              borderRadius={15}
              onClick={closeAgreementsMessage}
              position="absolute"
              top={-15}
              right={-15}
            >
              Close
            </ButtonIcon>

            <Typography type="type2">
              {agreementsCount === 1
                ? `Você precisa ler e aceitar o seguinte termo:`
                : 'Os termos abaixo precisam ser lidos e aceitos:'}
            </Typography>

            {Object.keys(agreements).map((agreementProductSlug) =>
              Object.keys(agreements[agreementProductSlug]).map((agreementClassUuid) => {
                const agreement = agreements[agreementProductSlug][agreementClassUuid];

                return (
                  <Flex
                    key={`${agreement.productClassAgreementUuid}`}
                    flexWrap="nowrap"
                    onClick={() => {
                      openAgreementContent(agreement.productSlug, agreement.productClassUuid);
                    }}
                    mt={2}
                    alignItems="flex-start"
                  >
                    <Typography type="type2" color="black80" lineHeight="1.3" mr="3px">
                      •
                    </Typography>
                    <Typography
                      type="type1"
                      style={{ cursor: 'pointer' }}
                      underline
                      color="black80"
                      lineHeight="1.3"
                    >
                      {agreement.agreementName}
                    </Typography>
                  </Flex>
                );
              })
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AgreementsMessage;
